module.exports = __webpack_public_path__ + "img/digit-1.52e3d9e7.png";